



















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list/index'
import AbpBase from '@/lib/abpbase'
import rewardPointGameApi from '@/api/marketing/rewardPointGame/index.ts'
@Component({
  components: {}
})
export default class rewardPointGameSelect extends AbpBase {
  // 0 大转盘 1 刮刮乐
  @Prop({ type: Number, default: null })
  rewardPointGameType: number

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []

  columns: any[] = [
    {
      title: '活动名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '活动类型',
      key: 'activityTypeDisplayName',
      align: 'center'
    },
    {
      title: '活动开始时间',
      slot: 'beginTime',
      align: 'center'
    },
    {
      title: '活动结束时间',
      slot: 'endTime',
      align: 'center'
    },
    {
      title: '活动状态',
      key: 'activityStatus',
      align: 'center'
    }
  ]

  async mounted() {}
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.getPageList()
  }

  async getPageList() {
    await rewardPointGameApi
      .getRewardPointGameList(
        this.pageSize,
        this.pageIndex,
        this.rewardPointGameType
      )
      .then(res => {
        this.total = res.data.totalCount
        this.data = res.data.items
      })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.getPageList()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (currentRow.activityStatus != '活动已下架') {
      this.$emit('on-row-selected', currentRow)
      this.modal1 = false
    } else {
      this.$Notice.warning({
        desc: '不能选择已下架的活动'
      })
    }
  }

  cancelFn() {
    this.$emit('on-row-selected', null)
    this.modal1 = false
  }
}
